export const ORDERING_APP_IFRAME_URL =
  import.meta.env.VITE_ORDERING_APP_IFRAME_URL ||
  'https://secretpos-gibhrans1.replit.app';
